import {
  InvoiceOperationType,
  InvoiceOperationTypeLabel,
} from '@/core/domain/invoice/invoices/invoices.enums';
import { Select, SelectProps } from 'antd';

export default function SelectOperationType(props: SelectProps) {
  const options = Object.keys(InvoiceOperationTypeLabel).map((key) => ({
    value: key,
    label: InvoiceOperationTypeLabel[key as InvoiceOperationType],
  }));

  return <Select {...props} options={options} style={{ width: '100%' }} />;
}
